import type { IconProps } from "./types";

export function Edit({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
        ? color
        : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.2217 5.12109C20.2216 4.79726 20.0923 4.4868 19.8633 4.25781C19.6343 4.02884 19.3239 3.90039 19 3.90039C18.6762 3.90039 18.3658 4.02884 18.1367 4.25781L8.81252 13.582L8.23635 15.8838L10.5401 15.3076L19.8633 5.98535C20.0923 5.75631 20.2217 5.44501 20.2217 5.12109ZM22.0215 5.12109C22.0215 5.92234 21.7033 6.69122 21.1367 7.25781L11.6367 16.7578C11.5215 16.873 11.3768 16.9545 11.2188 16.9941L7.21877 17.9941C6.91208 18.0708 6.58685 17.9814 6.3633 17.7578C6.13991 17.5343 6.05042 17.2099 6.12698 16.9033L7.12698 12.9033L7.16409 12.7871C7.20913 12.6744 7.27697 12.5718 7.3633 12.4854L16.8633 2.98535C17.4299 2.41874 18.1987 2.09961 19 2.09961C19.8013 2.09961 20.5701 2.41874 21.1367 2.98535C21.7031 3.55187 22.0214 4.32005 22.0215 5.12109Z"
        fill={currentColor}
      />
      <path
        d="M2.09961 19.1113V5.88867C2.09967 5.14909 2.39403 4.43996 2.91699 3.91699C3.43996 3.39403 4.14909 3.09967 4.88867 3.09961H11.5C11.9971 3.09961 12.4004 3.50294 12.4004 4C12.4004 4.49706 11.9971 4.90039 11.5 4.90039H4.88867C4.62648 4.90045 4.37485 5.00405 4.18945 5.18945C4.00405 5.37485 3.90045 5.62648 3.90039 5.88867V19.1113C3.90045 19.3735 4.00405 19.6251 4.18945 19.8105C4.37485 19.9959 4.62648 20.0996 4.88867 20.0996H18.1113C18.3735 20.0996 18.6251 19.9959 18.8105 19.8105C18.9959 19.6251 19.0996 19.3735 19.0996 19.1113V12.5C19.0996 12.0029 19.5029 11.5996 20 11.5996C20.4971 11.5996 20.9004 12.0029 20.9004 12.5V19.1113C20.9003 19.8509 20.606 20.56 20.083 21.083C19.56 21.606 18.8509 21.9003 18.1113 21.9004H4.88867C4.14909 21.9003 3.43996 21.606 2.91699 21.083C2.39403 20.56 2.09967 19.8509 2.09961 19.1113Z"
        fill={currentColor}
      />
    </svg>
  );
}
